<div class="w-full flex flex-col gap-[0.75rem] px-[0.75rem] sm:px-[1rem] pb-3 lg:pb-0">
  @if (comment()) {
    <gc-comment-card
      class="max-w-[30rem] pb-[0.625rem]"
      [showCommentLabel]="false"
      [showBorder]="true"
      [showReadMoreButton]="true"
      [authorName]="authorName()"
      [authorDate]="authorDate()"
      [message]="message()"
      (readMore)="openPopup()">
    </gc-comment-card>
  } @else {
    <gc-comment-card-no-data
      class="max-w-[30rem] pb-[0.625rem]"
      [addPermissions]="[PermissionName.LeakDetection_Write_Comments]"
      (add)="openPopup()">
    </gc-comment-card-no-data>
  }
</div>
